import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e3c1751"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-page"
};
const _hoisted_2 = {
  class: "orderList"
};
import { onMounted, ref } from 'vue';
import { h } from 'vue';
import { DeleteOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { SysDictDataControllerService } from "../../generated";
import DictTag from "@/components/tool/DictTag";
import RightToolbar from "../components/tool/RightToolBar.vue";
import { Search, Refresh, ShoppingCartFull, Link, ChatDotSquare } from '@element-plus/icons-vue';
import { XiaoniuFrontedControllerService } from "../../generated/services/XiaoniuFrontedControllerService";
import { ElMessage, ElMessageBox } from 'element-plus';
// //温馨提示
// const toast: any = useToast();
//
// toast.success("温馨提示 - 如果支付失败，请重新下单再试", {
//   //选项
//   position: 'top-right',
// });
//删除订单
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderView',
  setup(__props) {
    const pageSizeOptions = ref(['10', '20', '30', '40', '50']);
    // const pageSizeOptions = ref<string[]>(['10', '20']);
    //选中的id
    const ids = ref([]);
    const router = useRouter();
    const multiple = ref(true);
    const loading = ref(false);
    const orderList = ref([]);
    const orderTotal = ref(0);
    const handleDelete = () => {
      ElMessageBox.confirm('是否确认删除这个订单?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 删除订单的接口
        const res = await XiaoniuFrontedControllerService.removeUsingDelete15(ids.value);
        if (res.code === 200) {
          await getList();
          ElMessage.success('删除成功');
        } else {
          ElMessage.error('删除失败');
        }
      }).catch(() => {
        ElMessage.info('取消删除');
      });
    };
    const queryFormRef = ref();
    //条件搜索
    const handleQuery = () => {
      getList();
    };
    const resetForm = queryForm => {
      if (!queryForm) return;
      queryForm.resetFields();
      queryParams.value = {
        ...queryParams.value,
        pageNum: 1
      };
      getList();
    };
    const getList = async () => {
      loading.value = true;
      const res = await XiaoniuFrontedControllerService.listUsingGet16(queryParams.value);
      if (res.code === 200) {
        orderList.value = res.rows;
        orderTotal.value = res.total;
        loading.value = false;
      }
    };
    onMounted(() => {
      //清理浏览器的参数
      clearQueryParams();
      // 获取字典数据
      getDicType();
      // 获取列表数据
      getList();
    });
    const handleSelectionChange = selection => {
      ids.value = selection.map(item => item.id);
      multiple.value = !selection.length;
    };
    const payOrder = async orderNo => {
      const res = await XiaoniuFrontedControllerService.payUsingPost(orderNo);
      return res;
    };
    const handlePay = async row => {
      const payRes = await payOrder(row.orderId);
      //跳转到支付页面
      window.location = payRes.paymentUrl;
    };
    const handleLink = row => {
      if (row.payLink == null || row.payLink === '') {
        ElMessage.error("系统中没有存在该项目的链接，请联系站长!");
      } else {
        window.open(row.payLink, '_blank');
      }
    };
    const queryParams = ref({
      pageNum: 1,
      pageSize: 20,
      orderId: null,
      projectName: null,
      projectType: null,
      type: null,
      status: null
    });
    const orderTypeList = ref([]);
    const packageTypeList = ref([]);
    const projectTypeList = ref([]);
    const showSearch = ref(true);
    //获取字典数据
    const getSysDicType = async dicType => {
      //获取字典数据
      const res = await SysDictDataControllerService.dictTypeUsingGet(dicType);
      return res;
    };
    const clearQueryParams = () => {
      // 获取当前路由的路径和查询参数
      const {
        fullPath
      } = router.currentRoute.value;
      // 通过分割路径和查询参数来清除查询参数
      const cleanPath = fullPath.split('?')[0];
      // 使用 Vue Router 替换当前路由 URL，不带查询参数
      router.replace({
        path: cleanPath
      });
    };
    const getDicType = async () => {
      // 获取字典数据
      const resProjectType = await getSysDicType('project_type');
      if (resProjectType.code === 200) {
        projectTypeList.value = resProjectType.data;
      }
      const resOrderType = await getSysDicType('order_type');
      if (resOrderType.code === 200) {
        orderTypeList.value = resOrderType.data;
      }
      const resPackageType = await getSysDicType('package_type');
      if (resPackageType.code === 200) {
        packageTypeList.value = resPackageType.data;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_a_button = _resolveComponent("a-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_MyPaginationOrder = _resolveComponent("MyPaginationOrder");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 24,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(_component_el_form, {
            model: queryParams.value,
            inline: true,
            "label-width": "68px",
            class: "queryForm",
            ref_key: "queryFormRef",
            ref: queryFormRef
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "订单编号",
              prop: "orderId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: queryParams.value.orderId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.value.orderId = $event),
                placeholder: "请输入订单编号",
                clearable: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "项目名称",
              prop: "projectName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: queryParams.value.projectName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.value.projectName = $event),
                placeholder: "请输入项目名称",
                clearable: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "项目类型",
              prop: "projectType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: queryParams.value.projectType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.value.projectType = $event),
                placeholder: "请选择项目类型",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectTypeList.value, dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.dictValue,
                    label: dict.dictLabel,
                    value: dict.dictValue
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "套餐类型",
              prop: "type"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: queryParams.value.type,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => queryParams.value.type = $event),
                placeholder: "请选择套餐类型",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageTypeList.value, dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.dictValue,
                    label: dict.dictLabel,
                    value: dict.dictValue
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "订单状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: queryParams.value.status,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => queryParams.value.status = $event),
                placeholder: "请选择订单状态",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderTypeList.value, dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.dictValue,
                    label: dict.dictLabel,
                    value: dict.dictValue
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Search),
                onClick: handleQuery
              }, {
                default: _withCtx(() => [_createTextVNode("搜索")]),
                _: 1
              }, 8, ["icon"]), _createVNode(_component_el_button, {
                icon: _unref(Refresh),
                onClick: _cache[5] || (_cache[5] = $event => resetForm(queryFormRef.value))
              }, {
                default: _withCtx(() => [_createTextVNode("重置")]),
                _: 1
              }, 8, ["icon"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), [[_vShow, showSearch.value]]), _createVNode(_component_el_row, {
            gutter: 10,
            class: "mb8",
            style: {
              "display": "flex",
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                danger: "",
                type: "primary",
                icon: h(_unref(DeleteOutlined)),
                disabled: multiple.value,
                onClick: handleDelete
              }, {
                default: _withCtx(() => [_createTextVNode("删除订单 ")]),
                _: 1
              }, 8, ["icon", "disabled"])]),
              _: 1
            }), _createVNode(RightToolbar, {
              showSearch: showSearch.value,
              "onUpdate:showSearch": _cache[6] || (_cache[6] = $event => showSearch.value = $event),
              onQueryTable: getList
            }, null, 8, ["showSearch"])]),
            _: 1
          }), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: orderList.value,
            onSelectionChange: handleSelectionChange
          }, {
            empty: _withCtx(() => [_createTextVNode("暂无数据")]),
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection",
              width: "55",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "订单编号",
              align: "center",
              prop: "orderId",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              label: "项目编号",
              align: "center",
              prop: "projectId"
            }), _createVNode(_component_el_table_column, {
              label: "项目名称",
              align: "center",
              prop: "projectName",
              width: "200"
            }), _createVNode(_component_el_table_column, {
              label: "项目类型",
              align: "center",
              prop: "projectType",
              width: "100"
            }, {
              default: _withCtx(scope => [projectTypeList.value.length ? (_openBlock(), _createBlock(_unref(DictTag), {
                key: 0,
                "dict-list": projectTypeList.value,
                "color-type": 0,
                "dic-value": scope.row.projectType
              }, null, 8, ["dict-list", "dic-value"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "套餐类型",
              align: "center",
              prop: "type"
            }, {
              default: _withCtx(scope => [packageTypeList.value.length ? (_openBlock(), _createBlock(_unref(DictTag), {
                key: 0,
                "color-type": 2,
                "dict-list": packageTypeList.value,
                "dic-value": scope.row.type
              }, null, 8, ["dict-list", "dic-value"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "订单价格",
              align: "center",
              prop: "totalPrice"
            }), _createVNode(_component_el_table_column, {
              label: "下单时间",
              align: "center",
              prop: "createTime",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              label: "支付时间",
              align: "center",
              prop: "payTime",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              label: "订单状态",
              align: "center",
              prop: "status"
            }, {
              default: _withCtx(scope => [orderTypeList.value.length ? (_openBlock(), _createBlock(_unref(DictTag), {
                key: 0,
                "color-type": 1,
                "dict-list": orderTypeList.value,
                "dic-value": scope.row.status
              }, null, 8, ["dict-list", "dic-value"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              "class-name": "small-padding fixed-width",
              fixed: "right"
            }, {
              default: _withCtx(scope => [parseInt(scope.row.status) === 0 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                link: "",
                type: "primary",
                icon: _unref(ShoppingCartFull),
                onClick: $event => handlePay(scope.row)
              }, {
                default: _withCtx(() => [_createTextVNode("支付 ")]),
                _: 2
              }, 1032, ["icon", "onClick"])) : _createCommentVNode("", true), parseInt(scope.row.status) === 1 && scope.row.payLink && scope.row.payLink.trim() !== '' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                link: "",
                type: "primary",
                icon: _unref(Link),
                onClick: $event => handleLink(scope.row)
              }, {
                default: _withCtx(() => [_createTextVNode("链接 ")]),
                _: 2
              }, 1032, ["icon", "onClick"])) : _createCommentVNode("", true), parseInt(scope.row.status) === 1 && (!scope.row.payLink || scope.row.payLink.trim() === '') ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                link: "",
                type: "primary",
                icon: _unref(ChatDotSquare)
              }, {
                default: _withCtx(() => [_createTextVNode("咨询站长 ")]),
                _: 1
              }, 8, ["icon"])) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_MyPaginationOrder, {
            currentPage: queryParams.value.pageNum,
            "onUpdate:currentPage": _cache[7] || (_cache[7] = $event => queryParams.value.pageNum = $event),
            pageSize: queryParams.value.pageSize,
            "onUpdate:pageSize": _cache[8] || (_cache[8] = $event => queryParams.value.pageSize = $event),
            pageSizeOptions: pageSizeOptions.value,
            total: orderTotal.value,
            onChange: getList
          }, null, 8, ["currentPage", "pageSize", "pageSizeOptions", "total"])])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});